module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_11_sp-63aeab06abba456cb712fc49180b26f4.png";